<!-- Overlay loading -->
<app-fullscreen-overlay [isOverlayLoading]="isOverlayLoading"></app-fullscreen-overlay>

<div class="patient-detail d-flex flex-column flex-column-fluid">
  <div class="container-fluid">
    <!-- Patient Header Informations -->
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="container-fluid mt-1 ps-0">
            <div class="card">
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div class="col-md-7 p-4">
                    <div class="row align-items-center pb-0">
                      <div class="col-md-5 pb-2 pt-4">
                        <div class="card-subtitle fw-medium">
                          <span class="fw-bold">
                            {{ patientHeaderInformations?.name || "-" }}
                            {{ patientHeaderInformations?.lastName || "-" }},
                            {{ patientHeaderInformations?.age }},
                            {{ patientHeaderInformations?.gender[0] || "-" }}
                            <span class="badge badge-light-success">{{ "dermNo" | translate }}:
                              {{
                              patientHeaderInformations?.pidNo || "-"
                              }}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="card-subtitle fw-medium">
                        <span class="gray-font fs-14">
                          {{ skinTypeTextHeader() }}
                        </span>
                      </div>
                      <div class="card-subtitle fw-normal">
                        <span class="gray-font fs-14">
                          {{ generalAppearanceTextHeader() }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Back To Consultation & New Consultation & Follow Up Consultation -->
                  <div class="col-md-5 d-grid gap-2 d-md-flex justify-content-md-end p-10">
                    <a *ngIf="
                        caseIdFromPatientDetail;
                        else notComeFromPatientDetail
                      " [routerLink]="[
                        '/consultation/detail',
                        recordIdFromPatientDetail
                      ]" class="btn btn-secondary btn-sm fw-bold" type="button">{{ "backToConsultation" | translate
                      }}</a>
                    <ng-template #notComeFromPatientDetail>
                      <div *ngIf="
                          appointmentIdFromAppointmentList;
                          else noAppointment
                        ">
                        <ng-container *ngFor="
                            let type of [
                              'newConsultation',
                              'followUpConsultation'
                            ]
                          ">
                          <a [routerLink]="
                              getActionButtonConfig(false, type).routerLink
                            " [class]="getActionButtonConfig(false, type).class" type="button">
                            {{
                            getActionButtonConfig(false, type).label
                            | translate
                            }}
                          </a>
                        </ng-container>
                      </div>
                      <ng-template #noAppointment>
                        <ng-container *ngFor="
                            let type of [
                              'newConsultation',
                              'followUpConsultation'
                            ]
                          ">
                          <a [routerLink]="
                              getActionButtonConfig(true, type).routerLink
                            " [class]="getActionButtonConfig(true, type).class" type="button">
                            {{
                            getActionButtonConfig(true, type).label
                            | translate
                            }}
                          </a>
                        </ng-container>
                      </ng-template>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Patient Case Informations -->
    <div class="container-fluid">
      <div class="row" style="width: 100%">
        <div class="cards-area">
          <!-- Left Card -->
          <div class="pt-2 pe-2 col-md-5">
            <div class="container card left-card py-6 px-5 pt-3">
              <button class="fullscreen-button">
                <i class="fa-solid fa-expand"></i>
              </button>
              <!-- Medical History Tab -->
              <div class="tab-content tab-content-style" id="myTabContent">
                <div class="tab-pane fade show active" id="caseInformation" role="tabpanel">
                  <div class="container mt-2 card-overflow px-0 overflow-hidden">
                    <div class="lesion-characteristic-container">
                      <p class="title text-start fs-6 pt-3 mb-2">
                        {{ "personalInformation" | translate }}
                      </p>
                      <div class="custom-hr">
                        <div class="progress-bar"></div>
                      </div>
                      <div class="skin-type-options pt-2 d-flex justify-content-start gap-3">
                        <label class="d-flex align-items-center me-2">
                          <span class="gray-font">
                            <b>{{ "telephoneNumber" | translate }} :</b> {{ patientHeaderInformations?.phone || "-"
                            }}<br>
                            <b>{{ "email" | translate }} :</b> {{ patientHeaderInformations?.email || "-" }}<br>
                            <b *ngIf="address && address !== ''">{{ "address" | translate }} :</b>
                            {{ address }}
                          </span>
                        </label>
                      </div>
                    </div>
                    <!-- MEDICAL HISTORY AREA -->
                    <div class="medicalHistory-container">
                      <p class="title text-start fs-6 pt-0 mb-2">
                        {{
                        patientIdFromAppointmentList || patientId
                        ? ("prepMedicalHistoryTab" | translate)
                        : ("medicalHistory" | translate)
                        }}
                      </p>
                      <div class="custom-hr">
                        <div class="progress-bar"></div>
                      </div>
                      <div *ngIf="medicalHistoryAreaText(); else noMedicalHistory"
                        class="skin-type-options pt-2 d-flex justify-content-start gap-3">
                        <label class="d-flex align-items-center me-2">
                          <span class="gray-font" [innerHTML]="medicalHistoryAreaText()"></span>
                        </label>
                      </div>
                      <ng-template #noMedicalHistory>
                        <p class="pt-2 gray-font">
                          {{ "noMedicalHistory" | translate }}
                        </p>
                      </ng-template>
                    </div>

                    <!-- MEDICATIONS AREA -->
                    <div class="dermologic-diseases-container">
                      <p class="title text-start fs-6 pt-3 mb-2">
                        {{ "medications" | translate }}
                      </p>
                      <div class="custom-hr">
                        <div class="progress-bar"></div>
                      </div>
                      <div *ngIf="
                          medicationsDiseasesAreaText();
                          else noMedications
                        " class="skin-type-options pt-2 d-flex justify-content-start gap-3">
                        <label class="d-flex align-items-center me-2">
                          <span class="gray-font" [innerHTML]="medicationsDiseasesAreaText()"></span>
                        </label>
                      </div>
                      <ng-template #noMedications>
                        <p class="pt-2 gray-font">
                          {{ "noMedication" | translate }}
                        </p>
                      </ng-template>
                    </div>
                    <!-- LESION CHARACTERISTIC AREA -->
                    <div class="lesion-characteristic-container">
                      <p class="title text-start fs-6 pt-3 mb-2">
                        {{ "lesionCharacteristic" | translate }}
                      </p>
                      <div class="custom-hr">
                        <div class="progress-bar"></div>
                      </div>
                      <div *ngIf="
                          lesionCharacteristicAreaText();
                          else noMedications
                        " class="skin-type-options pt-2 d-flex justify-content-start gap-3">
                        <label class="d-flex align-items-center me-2">
                          <span class="gray-font" [innerHTML]="lesionCharacteristicAreaText()"></span>
                        </label>
                      </div>
                      <ng-template #noMedications>
                        <p class="pt-2 gray-font">
                          {{ "noLesionCharacteristics" | translate }}
                        </p>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Right Card -->
          <div class="ps-0 pt-2 pe-0 col-md-7">
            <div class="card right-card">
              <div class="card-body p-0">
                <!-- Right Side Tabs -->
                <ul class="nav right-bars nav-tabs nav-line-tabs nav-line-tabs-2x fs-6 mx-5 mt-3 pe-5" role="tablist">
                  <li class="nav-item" role="presentation">
                    <a #rightFirstTab class="nav-link text-gray-800 active" data-bs-toggle="tab" href="#caseImage"
                      aria-selected="true" tabindex="-1" role="tab">
                      <span *ngIf="isCaseActivated; else caseNotActivated">
                        {{ "case" | translate }} {{ caseNo }}
                        {{ "images" | translate }}
                      </span>
                      <ng-template #caseNotActivated>
                        {{ "draft" | translate }}
                      </ng-template>
                      {{
                      "(" +
                      (patientHeaderInformations?.createdDate
                      | date : "dd-MM-yyyy") +
                      ")"
                      }}</a>
                  </li>
                  <li class="nav-item" role="presentation" [ngClass]="
                      caseIdFromPatientDetail && aiImages?.allImagesExist
                        ? 'nav-item'
                        : 'd-none'
                    ">
                    <a class="nav-link text-gray-800" data-bs-toggle="tab" href="#aiReport" aria-selected="false"
                      role="tab">{{ "aiReport" | translate }}</a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a class="nav-link text-gray-800" data-bs-toggle="tab" href="#consultationReport"
                      aria-selected="false" tabindex="-1" role="tab">{{ "consultationReport" | translate }}</a>
                  </li>

                  <li [ngClass]="!caseIdFromPatientDetail ? 'nav-item' : 'd-none'" role="presentation">
                    <a class="nav-link text-gray-800" data-bs-toggle="tab" href="#chatWithDermatolog"
                      aria-selected="false" tabindex="-1" role="tab">{{ "chatWithDermatolog" | translate }}</a>
                  </li>

                  <li [ngClass]="!caseIdFromPatientDetail ? 'nav-item' : 'd-none'" role="presentation">
                    <a class="nav-link text-gray-800" data-bs-toggle="tab" href="#qrCode" aria-selected="false"
                      tabindex="-1" role="tab">{{ "qrCode" | translate }}</a>
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="caseImage" role="tabpanel">
                    <div class="col card-overflow overflow-hidden">
                      <div class="px-0">
                        <button class="fullscreen-button">
                          <i class="fa-solid fa-expand"></i>
                        </button>

                        <div class="row g-3 px-5 px-3 mt-0" *ngIf="!showFullImgCard?.src">
                          <div *ngFor="let image of patientImages; let i = index" class="col-3">
                            <div class="img-square" (dblclick)="openFullImgCard(image)">
                              <img [src]="image.src" class="img-fluid rounded img-thumbnail border-0 p-0"
                                [alt]="image.alt" />
                            </div>
                          </div>
                        </div>
                        <div *ngIf="showFullImgCard?.src">
                          <app-full-img-card [image]="showFullImgCard"
                            (onCloseIconClick)="closeFullImgCard()"></app-full-img-card>
                        </div>
                      </div>
                    </div>
                    <!-- Patient Images Modal -->
                    <div *ngFor="let image of patientImages" class="modal fade" [id]="image.id" tabindex="-1"
                      aria-labelledby="imageModalLabel" aria-hidden="true" data-bs-backdrop="true"
                      data-bs-keyboard="true">
                      <div class="modal-dialog modal-xl">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="imageModalLabel">
                              {{ "skinPreview" | translate }}
                            </h5>
                            <button type="button" class="btn-close cursor-pointer" data-bs-dismiss="modal"
                              aria-label="Close" (click)="closeModal()"></button>
                          </div>
                          <div class="modal-body text-center pt-0">
                            <img [src]="image.src" id="modalImage" class="img-fluid" width="65%"
                              alt="Responsive image" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id="aiReport" role="tabpanel" [ngClass]="
                      caseIdFromPatientDetail
                        ? 'tab-pane fade h-100 container-flex'
                        : 'd-none'
                    ">
                    <div *ngIf="showImageGalleryAi && !fullscreenImageAi">
                      <div class="row px-4" style="margin-top: 0px">
                        <div class="col-md-12 mt-10">
                          <app-gauge-chart [gaugeRate]="aiImages.gaugeRate"></app-gauge-chart>
                        </div>
                        <div class="col-md-12 mt-0 container-flex">
                          <p class="mb-4 ms-1">
                            {{ "imageAnalysis" | translate }}
                          </p>
                          <div class="image-grid">
                            <img [src]="
                                aiImages.spaceImage ||
                                '/assets/media/not-found.jpeg'
                              " (error)="onImageError($event)" class="image-analysis" (dblclick)="
                                showAiImagesFullscreen(aiImages.spaceImage)
                              " />
                            <img [src]="
                                aiImages.saturationSpaceImage ||
                                '/assets/media/not-found.jpeg'
                              " (error)="onImageError($event)" class="image-analysis" (dblclick)="
                                showAiImagesFullscreen(
                                  aiImages.saturationSpaceImage
                                )
                              " />
                          </div>
                        </div>
                        <p class="mt-5">
                          {{ "cbirAnalysis" | translate }}
                        </p>
                        <div class="col-md-12 mt-5">
                          <div class="cbir-grid">
                            <div class="image-container">
                              <span class="image-label">{{
                                aiImages.cbir1Value
                                }}</span>
                              <img [src]="
                                  aiImages.cbir1Image ||
                                  '/assets/media/not-found.jpeg'
                                " (error)="onImageError($event)" class="image-analysis" (dblclick)="
                                  showAiImagesFullscreen(aiImages.cbir1Image)
                                " />
                            </div>
                            <div class="image-container">
                              <span class="image-label">{{
                                aiImages.cbir2Value
                                }}</span>
                              <img [src]="
                                  aiImages.cbir2Image ||
                                  '/assets/media/not-found.jpeg'
                                " (error)="onImageError($event)" class="image-analysis" (dblclick)="
                                  showAiImagesFullscreen(aiImages.cbir2Image)
                                " />
                            </div>
                            <div class="image-container">
                              <span class="image-label">{{
                                aiImages.cbir3Value
                                }}</span>
                              <img [src]="
                                  aiImages.cbir3Image ||
                                  '/assets/media/not-found.jpeg'
                                " (error)="onImageError($event)" class="image-analysis" (dblclick)="
                                  showAiImagesFullscreen(aiImages.cbir3Image)
                                " />
                            </div>
                            <div class="image-container">
                              <span class="image-label">{{
                                aiImages.cbir4Value
                                }}</span>
                              <img [src]="
                                  aiImages.cbir4Image ||
                                  '/assets/media/not-found.jpeg'
                                " (error)="onImageError($event)" class="image-analysis" (dblclick)="
                                  showAiImagesFullscreen(aiImages.cbir4Image)
                                " />
                            </div>
                            <div class="image-container">
                              <span class="image-label">{{
                                aiImages.cbir5Value
                                }}</span>
                              <img [src]="
                                  aiImages.cbir5Image ||
                                  '/assets/media/not-found.jpeg'
                                " (error)="onImageError($event)" class="image-analysis" (dblclick)="
                                  showAiImagesFullscreen(aiImages.cbir5Image)
                                " />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="reportError">
                      <p class="fs-5 mb-0">
                        {{ reportError }}
                      </p>
                    </div>
                    <div class="tab-content container-flex h-100" *ngIf="fullscreenImageAi">
                      <div class="container-flex h-100">
                        <div class="row h-100">
                          <div class="col card-overflow overflow-hidden">
                            <div class="px-0 position-relative h-100">
                              <button (click)="closeAiImagesFullscreen()" class="fullscreen-button">
                                <i class="fa-solid fa-close fs-1 img-close-icon"></i>
                              </button>
                              <div class="row position-relative h-100">
                                <img class="case-image p-0" [src]="fullscreenImageAi" [alt]="fullscreenImageAi" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Consultation Report -->
                  <div class="tab-pane fade mx-5 my-3" id="consultationReport" role="tabpanel">
                    <div *ngIf="consultationReportError">
                      <p class="fs-5 mb-0">{{ consultationReportError }}</p>
                    </div>
                  </div>

                  <!-- Chat Field -->
                  <div class="tab-pane fade" id="chatWithDermatolog" role="tabpanel">
                    <div class="col">
                      <div class="container px-0">
                        <button class="fullscreen-button">
                          <i class="fa-solid fa-expand"></i>
                        </button>
                        <div class="card border-0 mx-5">
                          <div class="card-body p-0" style="height: 540px">
                            <!-- <div
                              *ngIf="otherUserName"
                              class="other-user-name-area fw-semibold"
                            >
                              {{ otherUserName }}
                            </div> -->
                            <div *ngIf="chatList?.length; else noChat" class="chat-card" #chatContainer>
                              <div *ngFor="let chatItem of chatList" class="chat-item my-3 me-3" [ngClass]="{
                                  'current-user':
                                    currentUser?.id === chatItem.createdUserId
                                }">
                                <div class="d-flex align-items-center gap-2 mb-1" [ngClass]="{
                                    'flex-row-reverse':
                                      currentUser?.id !==
                                      chatItem?.createdUserId
                                  }">
                                  <span class="fs-12 text-hour">{{
                                    chatItem?.relativeTime
                                    }}</span>
                                  <h5 class="card-title" style="font-size: 12px; margin-top: 8px">
                                    {{
                                    currentUser?.id ===
                                    chatItem?.createdUserId
                                    ? ("you" | translate)
                                    : chatItem?.createdUserName
                                    }}
                                  </h5>
                                  <!-- User Avatars -->
                                  <img *ngIf="
                                      currentUser?.id ===
                                        chatItem?.createdUserId;
                                      else otherUser
                                    " [src]="currentUserAvatar" alt="image"
                                    class="rounded-circle profile-image-size" />
                                  <ng-template #otherUser>
                                    <img [src]="otherUserAvatar" alt="image"
                                      class="rounded-circle profile-image-size" />
                                  </ng-template>
                                </div>
                                <p class="card-text mt-6 mb-5 fs-4 p-4 rounded-4" style="margin: 0px !important"
                                  [class.bg-light-pink]="
                                    currentUser?.id !== chatItem?.createdUserId
                                  " [class.bg-light-blue]="
                                    currentUser?.id === chatItem?.createdUserId
                                  " [ngClass]="{
                                    'text-end':
                                      currentUser?.id ===
                                      chatItem?.createdUserId
                                  }">
                                  {{ chatItem?.message }}
                                  <span *ngIf="chatItem?.chatFiles.length">
                                    <i (click)="
                                        downloadChatFile(
                                          chatItem.chatFiles[0]
                                            .chatFileFolderPath,
                                          chatItem.chatFiles[0].chatFileName
                                        )
                                      " class="fa-solid fa-file-arrow-down d-block mt-1 cursor-pointer"></i>
                                  </span>
                                </p>
                                <div class="separator"></div>
                              </div>
                            </div>

                            <ng-template #noChat>
                              <p class="my-3">
                                {{ "noChatToBeDisplayedHere" | translate }}
                              </p>
                            </ng-template>

                            <!-- Answer input area -->
                            <div
                              class="col d-flex mt-2 justify-content-between align-items-center mt-10 gap-4 answer-input-area bg-white">
                              <label class="btn btn-link p-0">
                                <div class="d-inline-flex">
                                  <i class="fa-solid fa-paperclip cursor-pointer" [ngClass]="
                                      isChatSending
                                        ? 'disable-send-chat-btn'
                                        : 'cursor-pointer'
                                    " (click)="handleFileClick($event)">
                                    <div *ngIf="fileCount > 0" class="file-count">
                                      1
                                    </div>
                                  </i>
                                </div>
                                <input type="file" #fileInput style="display: none"
                                  (change)="handleFileUpload($event)" />
                              </label>
                              <input type="text" class="form-control border-0 ps-0"
                                style="outline: none; box-shadow: none" [placeholder]="
                                  'answerToDermatologist' | translate
                                " [(ngModel)]="messageText" (keydown.enter)="
                                  !isChatSending && sendChat(consultationId)
                                " />
                              <button (click)="sendChat(consultationId)" class="btn btn-dark btn-sm fw-bold" [ngClass]="
                                  isChatSending
                                    ? 'disable-send-chat-btn'
                                    : 'cursor-pointer'
                                ">
                                {{ "send" | translate }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- QRCode Field -->
                  <div class="tab-pane fade" id="qrCode" role="tabpanel">
                    <div class="col">
                      <div class="container px-0">
                        <button class="fullscreen-button">
                          <i class="fa-solid fa-expand"></i>
                        </button>
                        <div class="card border-0">
                          <div class="card-body p-0">
                            <div *ngIf="qrCodeDetails?.url; else noQrCode" class="" #qrCodeContainer>
                              <div class="qr-img-area">
                                <img alt="qrcode" [src]="qrCodeDetails.url" />
                              </div>
                            </div>

                            <ng-template #noQrCode>
                              <p class="my-3 mx-5">
                                {{ "noQRCodeDisplayedHere" | translate }}
                              </p>
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Consultation Time Lines -->
        <div class="col-md-12 pe-0 pt-2" *ngIf="consultationTimeLines?.length">
          <div class="row">
            <div class="col pe-0">
              <div class="container-fluid ps-0">
                <div class="card">
                  <div class="container-fluid" *ngIf="consultationTimeLines?.length">
                    <app-case-timeline [consultationId]="consultationId" [consultationTimeLines]="consultationTimeLines"
                      [(selectedTimeline)]="selectedTimeline" (selectedTimelineChange)="
                        onChangeSelectedTimeline($event)
                      "></app-case-timeline>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>